import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { EditTemplateBasicFormComponent } from '@app/shared/component/discovery-setup-detail/widgets/contact/sub-component/stepper-manage-contact-list/create-associated-form/edit-template-basic-form/edit-template-basic-form.component';
import { map, startWith } from 'rxjs/operators';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'mx-select-vault-modal',
  templateUrl: './mx-select-vault-modal.component.html',
  styleUrl: './mx-select-vault-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MxSelectVaultModalComponent implements OnInit, OnDestroy {
  myControl = new FormControl('');
  options: string[] = ['One', 'Two', 'Three'];

  @ViewChild(EditTemplateBasicFormComponent) editTemplateBasicForm!: EditTemplateBasicFormComponent;
  form: FormGroup;
  name: string = '';
  userObject;
  subscription = new Subscription();
  vault_id: any;
  current_template;
  documentForm;
  forms: any;
  formData = [];
  securityStateObject;
  vaults: any = [];
  allVaults = [];
  filteredVaults$: Observable<any[]>;
  constructor(
    public dialogRef: MatDialogRef<MxSelectVaultModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private vaultService$: VaultStoreEffects
  ) {
    this.filteredVaults$ = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value) => this.filterVaults(value || ''))
    );
  }

  ngOnInit(): void {
    this.subscription.add(
      this.vaultService$.vaultObject.subscribe((state) => {
        this.vaults = state.vaults;
      })
    );
  }

  filterVaults(searchText: string): any[] {
    const lowerCaseSearch = searchText.toLowerCase();
    return this.vaults.filter((vault) => vault.name.toLowerCase().includes(lowerCaseSearch));
  }

  create() {
    this.dialogRef.close(this.myControl.value);
  }

  getDicoveryVaultName(value: any) {
    return value?.name;
  }

  handleVaultNameForMultipleNames(vaultName) {
    // return vaultName;
    const hasDuplicateNames = vaultName.trim().split('&');
    if (!hasDuplicateNames[1]) return vaultName;
    const secondName = hasDuplicateNames[1].trim().split('vault');
    return `${hasDuplicateNames[0] + ' ' + '&' + ' ' + secondName[0].trim()}'s Vault`;
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
